import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';

@Component({
  selector: 'app-budgets',
  templateUrl: './budgets.component.html',
  styleUrls: ['./budgets.component.css']
})
export class BudgetsComponent implements OnInit {

  cotizaciones = [];

  constructor(private resolver: ResolverService,private guiFlow: GuiFlowService,private router: Router,private route: ActivatedRoute) { }

  ngOnInit(): void {
    const data = this.route.snapshot.data['budgetsInfo'];
    this.cotizaciones = data.cotizaciones.data;
  }

  getBudgetList(){
    return this.cotizaciones;
  }

  reload(){
    this.resolver.getBackendDataForQueryId('cotizaciones',true,null);
  }

  getLink(obj){
    return this.resolver.getBugdetLinkAccess(obj.token);
  }

  openLink(obj){
    window.open(this.getLink(obj));
  }

  goToCreateBudget(){
    this.router.navigateByUrl('cotizacion');
  }

  isLoading(){
    return this.resolver.isLoading('cotizaciones');
  }

  copyToClipBoard(value){
    navigator.clipboard.writeText(this.getLink(value));
    this.guiFlow.openSimpleSnackBar('Copied to clipboard 💾', 'info' );
  }

  getPhotoUrl(url){
    let urlOut;
    if(url){
      urlOut = 'https://voyjaleas-assets-worker.sebtec12.workers.dev/'+url;
    }else{
      urlOut = '';
    }
    return urlOut;
  }


}
